import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/bmi-calculator")({
  component: BmiCalculatorLayout,
});

function BmiCalculatorLayout() {
  return <Outlet />;
}
